import { Button, styled } from "@mui/material";
import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { openStore } from "../../utils/device";

const style = {
  position: "absolute" as "absolute",
  bottom: 0,
  width: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
};

const parentContainerStyle = {
  padding: "8px 24px", display: "flex", flexDirection: "column",
  alignItems: "center", gap: "1rem",
};

const boxContainerStyle = {
  "display": "flex",
  "justifyContent": "space-between",
  "alignItems": "center",
  "width": "100%",
  "> div": {
    display: "flex", gap: "1rem", alignItems: "center",
  },
};

export default function OpenAppModal() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(()=>{
    handleOpen();
  }, []);

  const OpenAppButton = styled(Button)({
    padding: "0.62rem 1.25rem 0.5rem",
    borderRadius: "6.25rem",
    fontSize: "0.625rem",
    fontWeight: "bold",
    backgroundColor: "#FEC20B",
    height: "unset",
    maxWidth: "112px",
    width: "100%",
  });


  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="open-app-title">
        <Box sx={style}>
          <Box className="w-full bg-white absolute bottom-0 h-[174px]
          max-h-[180px] rounded-t-[24.507px] rounded-t-[24.507px] rounded-b-none">
            <Box sx={parentContainerStyle}>
              <div>
                <Typography variant="h4" textAlign="center">GoodVets is better on the app!</Typography>
              </div>
              <Box sx={boxContainerStyle}>
                <Box>
                  <img src="/assets/icons/mobile_app_icon.svg" className="w-[29px] w-[29px]" alt={"logo"}/>
                  <Typography variant="h4">GoodVets App</Typography>
                </Box>
                <OpenAppButton onClick={openStore}>OPEN APP</OpenAppButton>
              </Box>
              <Box sx={boxContainerStyle}>
                <Box>
                  <img src="/assets/icons/globe.svg" className="w-[29px] w-[29px]" alt={"browser"}/>
                  <Typography variant="h4">Browser</Typography>
                </Box>
                <OpenAppButton onClick={handleClose} sx={{ background: "#FFFFFF", border: "1px solid #000000" }}>
                    Continue
                </OpenAppButton>
              </Box>
            </Box>

          </Box>
        </Box>
      </Modal>
    </div>
  );
}
